import * as React from "react";
import * as PropTypes from "prop-types";
import styles from "./Summary.module.css";
import widgetStyles from "css/widgets.module.css";
import FeesSummary from "./Fees/FeesSummary";
import Claimant from "./Claimant/Claimant";
import UIFooter from "components/UI/Footer";
import UIButtonPrimary from "components/UI/Button/Primary";
import UIButtonSecondary from "components/UI/Button/Secondary";
import { history } from "store";
import { Redirect } from "react-router-dom";

const Summary = props => {
  const { fees, claimantData, salesTaxData, workItemId, state, isDual, type, displayError, errorMessage, dummyVin } = props.data;

  if (!workItemId) {
    return <Redirect to="/" />;
  }

  return (
    <div className={styles.summary}>
      {displayError ? <div className={`${widgetStyles.base} ${widgetStyles.first_column}`}><div style={{fontWeight:"bold", position:"relative", top:"40%", paddingLeft:"50px", paddingRight:"50px", textAlign:"center"}}><label dangerouslySetInnerHTML={{ __html: errorMessage }}></label></div></div> :
        <FeesSummary
          className={`${widgetStyles.base} ${widgetStyles.first_column}`}
          isDual={isDual}
          fees={fees}
          state={state}
        />
      }
      <Claimant
        isDual={isDual}
        claimantData={claimantData}
        salesTaxData={salesTaxData}
        className={widgetStyles.base}
        isDummyVin={dummyVin}
      />
      <UIFooter className={widgetStyles.btnFooter}>
        <UIButtonPrimary
          id="viewPdfReport"
          name="View PDF Report"
          disabled={!fees || fees.length === 0}
          className={widgetStyles.btnFooter__button}
          onClick={() => props.onGeneratePDF({ workItemId, isDual, type })}
        >
          View PDF Report
        </UIButtonPrimary>

        <UIButtonSecondary
          id="backToWorkList"
          name="Back to Worklist"
          className={widgetStyles.btnFooter__button}
          onClick={() => history.push("/")}
        >
          Back to Worklist
        </UIButtonSecondary>
      </UIFooter>
    </div>
  );
};

Summary.propTypes = {
  data: PropTypes.shape({
    fees: PropTypes.array,
    totalPayment: PropTypes.string,
    totalRefunded: PropTypes.string,
    claimantData: PropTypes.array,
    workItemId: PropTypes.string
  }),
  onCancel: PropTypes.func,
  onGeneratePDF: PropTypes.func
};

Summary.defaultProps = {
  data: {
    fees: [],
    totalPayment: 0,
    totalRefunded: 0,
    claimantData: [],
    workItemId: ""
  },
  onCancel: () => {},
  onGeneratePDF: () => {}
};

export default Summary;
